import SearchSelect from "./SearchSelect"

/**
 * Picking a project, by typing.
 *
 * ── Why the code leads ──────────────────────────────────────────────────────
 *
 * "RECON · Q1 commission reconciliation" rather than the name alone, because
 * the code is what people quote in a thread, on an invoice line and in a task
 * id. Somebody who knows they want RECON should be able to type RECON.
 *
 * ── Why the client is underneath ────────────────────────────────────────────
 *
 * Two clients both have an "Onboarding". On one line those rows are
 * indistinguishable, and picking the wrong one puts a task on the wrong
 * tenant's board — which is the kind of mistake nobody reports, because from
 * the inside it just looks like the task went missing.
 */
export default function ProjectSelect({ projects = [], emptyLabel = "All projects", label = "Project", ...rest }) {
  return (
    <SearchSelect
      options={projects}
      label={label}
      emptyLabel={emptyLabel}
      getLabel={(project) => (project?.code ? `${project.code} · ${project.name}` : project?.name ?? "")}
      getCaption={(project) => project?.client_label || null}
      getSearchText={(project) => `${project.code ?? ""} ${project.client_label ?? ""}`}
      noOptionsText="No project matches"
      {...rest}
    />
  )
}
